// ConnectPatreonButton.tsx
import React, {useEffect} from "react";
import {config} from "../../../config";
import {useTypedSelector} from "../../../hooks/useTypedSelector";

export default function PatreonButton() {
    const {user} = useTypedSelector(state => state.auth);
    const handleConnect = () => {
        // Backend route that issues a 302 to Patreon’s /oauth2/authorize
     //   window.location.href = config.serverUrl + "/api/patreon/redirect?user_id=" + user.id;
        const url = `${config.serverUrl}/api/patreon/redirect?user_id=${user.id}`;
        window.open(url, "_blank");
    };

    useEffect(() => {
        const listener = (e: MessageEvent) => {
            if (e.data?.type === 'patreon_connected') {
                // refresh user data
                window.location.reload();
            }
        };
        window.addEventListener('message', listener);
        return () => window.removeEventListener('message', listener);
    }, []);

    return (
        <div className="patreonButtonContainer">
            {user.patreon_email && (
                <div className="patreonLabel">
                    Connected to: <span className={'patreonEmail'}>{user.patreon_email}</span>
                </div>
            )}

            <button onClick={handleConnect} className="patreonButton">
                {user.patreon_email ? "Reconnect Patreon" : "Connect Patreon"}
            </button>
        </div>
    );
}